import { render, staticRenderFns } from "./TabelaResultadosAtoAdmin.vue?vue&type=template&id=d9767ad8&scoped=true"
import script from "./TabelaResultadosAtoAdmin.vue?vue&type=script&lang=js"
export * from "./TabelaResultadosAtoAdmin.vue?vue&type=script&lang=js"
import style0 from "./TabelaResultadosAtoAdmin.vue?vue&type=style&index=0&id=d9767ad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9767ad8",
  null
  
)

export default component.exports